import {ReloadButton} from '@flexinet/ui-components';
import {Box} from '@mantine/core';
import {useQueryClient} from '@tanstack/react-query';
import {personasKeys} from '../hooks/usePersonasQuery';

export const ReloadRecordsButton = () => {
    const queryClient = useQueryClient();

    const handleReload = () => {
        queryClient.invalidateQueries({queryKey: personasKeys.all});
    };

    return (
        <Box mx='s'>
            <ReloadButton onClick={handleReload}/>
        </Box>
    );
};
